import React from "react";
import Grid from '@material-ui/core/Grid'
import { format } from 'date-fns';

import LockIcon from '@material-ui/icons/Lock';


const today = new Date();


const LockedLPList = (props) => {
  function daysConvert(date2) {
    let date1 = new Date();
    let oned = 30 * 24 * 60 * 60 * 1000;
    return Math.ceil((date2 - date1) / oned);
  }
  const dateAlign = (val) => {
    let myDate = new Date(1000*val);
    if(daysConvert(myDate)<=1){
      if(daysConvert(myDate)<=0){
        return "Withdrawn at"
      }else{
        return "in few days"
      }
    }else{
      return 'in ' + daysConvert(myDate)+' months'
    }
    // const today = Date.now();
  }
  function dateFormateForCard(date2) {
    let finaldate = new Date(1000*date2)
    // let finaldate = date2
    return finaldate.toLocaleString();
  }
  const financial = (num,digit,sint) => {
    if (sint == 'yes') {
      let val = num/1e18;
      return Number.parseFloat(val).toFixed(digit);
    }else{
      return Number.parseFloat(num).toFixed(digit);
    }
  }

 
  let hrefLink = "/lp-details?pair=" + props.name;
  return (
    <Grid 
      container 
      justify="space-between" 
      direction="row"
      xs={12}
      className="pb-2 mb-3"
      style={{borderBottom: '1px solid #16527c'}}
    >
      <div>
        <h4 className="mb-1 text-light">${financial(props.amount,2,'yes')} LP</h4>
        {/* <p className="mb-1 text-light"></p> */}
      </div>
      <div>
        <h4 className="mb-1 text-light text-right">{dateAlign(props.widrawDate)}</h4>
        <p className="mb-1 text-light text-right">{dateFormateForCard(props.widrawDate)}</p>
      </div>
    </Grid>
  );
}

export default LockedLPList;



